module.exports = __webpack_public_path__ + "static/media/Jeremy.8b1ab566.jpg";